/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 *
 * Example:
 * router.generate('/{gallery}/create/{slug}', {
 *     slug: 'bc',
 *     gallery: 'businesscards',
 *     new: 1
 * })
 *
 * Will generate /businesscards/create/bc?new=1
 */
define([], function() {
    return {
        /**
         * @param {string} url
         * @param {object} params
         * @param {(string|bool)} [locale] If undefined, current locale will be used. With false, the default one will be used
         * @return {string}
         */
        generate: function(url, params, locale) {
            let additionalQueryParams = [];

            for (var param in params) {
                if (this._isParamInUrl(url, param)) {
                    url = this._replaceParamWithValue(url, param, params[param]);
                } else {
                    additionalQueryParams.push(this._encodeQueryParam(param, params[param]));
                }
            }

            if (additionalQueryParams.length > 0) {
                url += '?' + additionalQueryParams.join('&');
            }

            return this._getEnvironmentPrefix() + this._getLocalePrefix(url, locale) + url;
        },

        /**
         * @param {string} url
         * @param {string} param
         * @return {boolean}
         * @private
         */
        _isParamInUrl: function(url, param) {
            return url.indexOf('{' + param + '}') !== -1;
        },

        /**
         * @param {string} url
         * @param {string} param
         * @param {string} value
         * @private
         */
        _replaceParamWithValue: function(url, param, value) {
            return url.replace('{' + param + '}', value);
        },

        /**
         * @param {string} key
         * @param {string} value
         * @return {string}
         * @private
         */
        _encodeQueryParam: function(key, value) {
            value = value === null || value === undefined ? '' : value;

            return encodeURIComponent(key) + '=' + encodeURIComponent(value);
        },

        /**
         * @return {string}
         * @private
         */
        _getEnvironmentPrefix: function() {
            const devPrefix = '/app_dev.php';
            const testPrefix = '/app_test.php';

            if (window.location.pathname.indexOf(devPrefix) === 0) {
                return devPrefix;
            } else if (window.location.pathname.indexOf(testPrefix) === 0) {
                return testPrefix;
            } else {
                return '';
            }
        },

        /**
         * @param {(string)} [url]
         * @param {(string|bool)} [locale]
         * @return {string}
         * @private
         */
        _getLocalePrefix: function(url, locale) {
            const adminPrefix = '/admin';
            if (url.indexOf(adminPrefix) === 0) {
                return '';
            }
            if (locale === undefined && ONP.config.defaultLocale !== ONP.locale) {
                return '/' + ONP.locale;
            } else if (locale && ONP.config.defaultLocale !== locale) {
                return '/' + locale;
            }

            return '';
        }
    };
});
